export default {
    listagem: {
        titulo_pagina: 'Lista de Métodos',
        novo: 'Criar novo Método',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Método encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Método',
            editar: 'Editar Método'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Método'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Método'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Método'
            },
            botao_salvar : 'Salvar Método'
        },
        create: {
            success: 'Método criado com Sucesso!',
            error: 'Error ao criar Método!'
        },
        update: {
            success: 'Método editado com Sucesso!',
            error: 'Error ao editar Método!'
        }
    }
}
